import { useEffect } from 'react'
import { reviewStore } from 'stores/Review'
import { ArticleInformalFeedbackRequests } from 'hooks/useInformalFeedbackRequests'

export function useArticleReviewSections(request: ArticleInformalFeedbackRequests) {
  const reviewToHighlight = getRequestToHighlight(request)

  useEffect(() => {
    if (reviewToHighlight) {
      reviewStore.select(reviewToHighlight)
    }
  }, [reviewToHighlight])

  useEffect(() => {
    if (request.informalFeedbackRequests.length === 0) {
      reviewStore.clear()
    }
  }, [request.informalFeedbackRequests.length])
}

export function getRequestToHighlight(request: ArticleInformalFeedbackRequests) {
  const requestedByMe = request.requestedByMe[0]
  const requestedByOthers = request.requestedByOthers[0]
  return requestedByMe || requestedByOthers
}
